<template>
    <div class="wrap">
        <MainHeader title="현장 접수 화면"/>
        <section>
            <section class="external">
                <div class="external_box" v-if="group != undefined && group != null">
                    <div class="content_title">
                        <h1>{{event.event_nm}}</h1>
                        <h3>
                            <!-- <p style="font-size:70%">일시 : <strong>{{event.event_start_date.substr(0,4)}}년
                                            {{event.event_start_date.substr(5,2)}}월
                                            {{event.event_start_date.substr(8,2)}}일</strong></p> -->
                            <!-- <p>장소 : <strong>웰스토리 예식장</strong></p> -->
                        </h3>
                        <p class="caption">
                        바쁘신 와중에 어려운 걸음 해주셔서 감사합니다.<br>
                        감사의 의미로 조그마한 선물을 준비했습니다.<br>
                        아래 정보를 입력해 주시면, 선물을 수령할 수 있는 링크를 전송해 드립니다.<br>
                        <br>
                        <!-- 메세지 발송 일시: {{event.gift_msg_send_date.substr(0,4)}}년
                        {{event.gift_msg_send_date.substr(5,2)}}월
                        {{event.gift_msg_send_date.substr(8,2)}}일  -->
                        <!-- {{event.gift_msg_send_time}} -->
                        </p>
                    
                        <ul class="external_thumb_list" v-if="cartList.length > 0">
                            <li v-for="(goods) in cartList" :key="goods.good_no">
                                <a href="#">
                                    <div class="thumb">
                                        <img :src="$store.getters['systemStore/getImgPath']+goods.img_path" :alt="goods.good_nm">
                                    </div>
                                    <!-- <p>빈폴 21SS 레트로 빈 새들백</p> -->
                                </a>
                            </li>
                        </ul>
                        <ul v-else>
                            등록된 상품이 없습니다.
                        </ul>
                    </div>

                    <div class="content_content">
                        <ul class="question_list">
                            <li>
                                <label class="question">이름</label>
                                <input type="text" placeholder="이름을 입력해주세요." maxlength="30" v-model="group.cell_nm">
                            </li>

                            <li>
                                <label class="question">전화번호</label>
                                <input type="tel" @keyup="setCellForm" maxlength="13" v-model="group.recvr_cell" placeholder="-없이 입력하세요.">
                            </li>
                        </ul>
                    </div>

                    <div class="input-form-checkbox txt-center">
                        <input type="checkbox" id="rul-agree" v-model="checked">
                        <label for="rul-agree"><i class="xi-check-min"></i>문자 발송을 위한 개인 정보의 이용에 동의합니다. <br><span class="sub">(개인정보 위탁 처리 : 삼성웰스토리 주식회사) </span></label>
                    </div>

                    <button class="btn_large" @click="save">저 장</button>

                </div>

                <div class="external_box" v-else>
                    <div class="content_title">
                        <h1>{{event.event_nm}}</h1>
                        <h3>
                            <p class="caption">
                                <br>
                                <br>
                                <br>
                                <br>
                                <br>
                                <br>
                                현장접수 그룹이 등록되어 있지 않아<br>
                                해당 서비스를 이용하실 수 없습니다.
                            </p>
                        </h3>
                    </div>
                    <div class="content_content">
                        <br>
                        <br>
                        <br>
                        <br>
                    </div>
                </div>
            </section>
            <Footer style="background:#fafafa;"/>
        </section>

        <!-- alert -->
        <div class="popup scene_01">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p v-html="alertMsg"></p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" onclick="modal('scene_01')">확 인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>
        
        <div class="popup scene_02">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p v-html="alertMsg"></p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" onclick="location.reload();">확 인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>
    </div>
</template>



<script>
import MainHeader from '@/components/MainHeader.vue'
import {api} from '@/api/index.js'
import EventBus from '@/service/EventBus'
import Footer from '@/components/MainFooter'
export default {
    data() {
        return {
            alertMsg: '',
            event: {},
            group: {},
            cartList: {},
            good_no: '',
            checked: false,
        }
    },
    methods: {
        fnAlert1(msg) {
            this.alertMsg = msg;
            $('.scene_01').addClass('active');
        },
        fnAlert2(msg) {
            this.alertMsg = msg;
            $('.scene_02').addClass('active');
        },
        selectGoods(goods){
            if(this.good_no != goods.good_no) {
                this.good_no = goods.good_no
            }
            else {
                this.good_no = '';
            }
            
        },
        setCellForm() {
            this.group.recvr_cell = this.group.recvr_cell.replace(/-/gi,"");
            this.group.recvr_cell = this.group.recvr_cell.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,"$1-$2-$3");
        },
        openModal(id) {
            EventBus.$emit('open-modal',id);
        },
        save() {
            var telPattern1 = /^01([0|1|6|7|8|9]?)/;
            var telPattern2 = /^01([0|1|6|7|8|9]?)-\d{3,4}-\d{4}$/;

            if(this.group.cell_nm === '' || this.group.cell_nm === undefined) {
                this.fnAlert1('이름을 입력해 주세요.');
                return;
            }
            this.group.cell_nm.trim();

            if (this.group.recvr_cell === '' || this.group.recvr_cell === undefined) {
                this.fnAlert1('전화번호를 입력하세요.');
                return;
            }
            if (!telPattern1.test(this.group.recvr_cell)) {
                this.fnAlert1('국내 전화번호만 입력 가능합니다.');
                return;
            }
            if (!telPattern2.test(this.group.recvr_cell)) {
                this.fnAlert1('올바른 전화번호 형식이 아닙니다.');
                return;
            }

            if(!this.checked) {
                this.fnAlert1('개인 정보 이용에 동의해 주세요.');
                return;
            }
            
            this.group.cell_nm.trim();
            this.group.recvr_cell.trim();

            api.postAsync('/recvr/insertSceneRecvr.do', this.group)
                .then(data=> {
                    this.fnAlert1(data.ret_msg);
                    this.$router.go();
                })
            
        }
    },
    async created() {
        await api.postAsync('/group/initSceneReception.do', {event_no: this.$route.params.event_no})
                .then(data=>{
                    console.log(data);
                    this.group = data.sceneGroup;
                    this.event = data.event;
                    if(this.group != null && this.group != undefined) {
                        this.cartList = data.cartList;

                        this.$set(this.group, 'event_no', this.$route.params.event_no);
                        this.$set(this.group, 'group_no', this.group.group_no);
                    }
                    
                    
                })
    },
    components: {MainHeader, Footer}
}
</script>

<style scoped>
.external_box::before {
    background: none;
}

.external .content_title h3{
    background: none;
    margin-top: -20px;
}
.input-form-checkbox input[type="checkbox"] + label{
    font-size: 105%;
}
</style>